import React from 'react';
import styled from 'styled-components';
import { ViewEvents } from '~admin/view/components/view-events/view-events.component';
import { Column } from '~common/components/column.component';
import { ScrollBar } from '~web/view/theme/utils';

export const ViewEventsPage: React.FunctionComponent = () => {
  return (
    <Container>
      <ViewEvents />
    </Container>
  );
};

const Container = styled(Column)`
  width: 100%;
  height: 100%;
  align-items: center;
  ${ScrollBar};
`;



// WEBPACK FOOTER //
// ./view/pages/view-events.page.tsx